<template>
    <div class="footer-columns-title">
        <div class="footer-columns-title-text">
            <slot />
        </div>
    </div>
</template>

<script>
    import { defineComponent } from '@vue/composition-api';
    export default defineComponent({
        name: 'FooterColumnsTitle',
    });
</script>

<style lang="scss" scoped>
    @import '~@superbet-group/web.lib.global-styles/type';
    @import '~@superbet-group/web.lib.global-styles/responsive';

    .footer-columns-title {
        padding-bottom: var(--space-padding-sm);
        border-bottom: 1px solid var(--system-border-on-elevation-primary);
        color: var(--system-text-on-elevation-primary);
        font-family: var(--system-title-default-family), sans-serif;
        font-size: var(--system-title-default-size);
        font-weight: $font-weight-bold;
        line-height: var(--system-title-default-line-height);
        letter-spacing: var(--system-title-default-letter-spacing);
        text-transform: uppercase;

        &-text {
            display: flex;
            align-items: center;
            height: 32px;
        }

        &:empty {
            padding-bottom: 0;
        }
    }
</style>
